import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from './shared/auth.service';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private auth: AuthService,
  ) {}

  ngOnInit() {
    // console.log('AppComponent Init');

    if (this.auth.token) {
      this.auth.renew();
    }

    this.auth.authenticationState.subscribe(async state => {
      if (state) {
      } else {
        if (
          !location.pathname.startsWith('/forgot') &&
          !location.pathname.startsWith('/recover') &&
          !location.pathname.startsWith('/download') &&
          !location.pathname.startsWith('/recommendation-letter')
        ) {
          this.router.navigate(['login']);
        }
      }
    });

    this.router.events.subscribe(evt => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      // window.scrollTo(0, 0);
    });
  }
}
